import { Send, Users } from "lucide-react";

const SPREADS = [[0.4, "Close together"], [0.75, "Wide"], [1, "Very wide"]];

/** Choir stacking: turn it on and every take on this track sings together, spread from left to right. */
export default function StackControls({ track, onChange, onSend }) {
  const stack = track.stack || { on: false, take_ids: [], spread: 0.75 };
  const voices = stack.on ? stack.take_ids.filter((id) => track.takes.some((t) => t.id === id)).length : 0;
  const toggle = () => onChange({ stack: { ...stack, on: !stack.on, take_ids: !stack.on && !stack.take_ids.length ? track.takes.map((t) => t.id) : stack.take_ids } });
  return (
    <div data-testid="rec-stack" data-on={stack.on ? "1" : "0"} className={`mt-3 rounded-2xl border p-3 ${stack.on ? "border-violet-300/35 bg-violet-500/[0.07]" : "border-white/[0.07] bg-black/20"}`}>
      <div className="flex flex-wrap items-center gap-2">
        <label className="flex cursor-pointer items-center gap-2 text-[13px] font-semibold">
          <input type="checkbox" data-testid="rec-stack-toggle" checked={stack.on} onChange={toggle} className="h-4 w-4 accent-violet-400" />
          <Users className="h-4 w-4 text-violet-200" /> Choir stack
        </label>
        {stack.on ? (
          <>
            <span data-testid="rec-stack-voices" className="rounded-full bg-violet-500/20 px-2 py-0.5 font-mono text-[10px] uppercase text-violet-100">{voices} voice{voices === 1 ? "" : "s"}</span>
            <select data-testid="rec-stack-spread" value={stack.spread} onChange={(e) => onChange({ stack: { ...stack, spread: Number(e.target.value) } })}
              className="ml-auto rounded-lg border border-white/10 bg-black/40 px-2 py-1 text-[11px] text-white focus:outline-none">
              {SPREADS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </select>
            <button type="button" data-testid="rec-stack-send" onClick={onSend} disabled={!voices} className="inline-flex items-center gap-1 rounded-full border border-violet-300/40 px-2.5 py-1 font-mono text-[10px] uppercase tracking-wider text-violet-100 hover:bg-violet-500/20 disabled:opacity-40">
              <Send className="h-3 w-3" /> Send stack to song
            </button>
          </>
        ) : null}
      </div>
      <p className="mt-1.5 text-[11px] text-white/50">
        {stack.on ? "Sing the same part again with Record — each new take joins the choir. Tick takes below to add or drop voices." : "Sing the same part several times and blend the takes into one fuller choir sound."}
      </p>
    </div>
  );
}
